export default __webpack_public_path__ + "static/media/wireless-bluetooth-3.69ebcddd.png";